const common = {
  Test: 'Test',
  Save: 'Save',
  Download: 'Download',
  Cancel: 'Cancel',
  Export: 'Export',
  Import: 'Import',
  OK: 'OK',
};

export default common;
